import { create } from 'zustand';

import type { CardId } from './types';

export type BoardEditingMode =
  | 'create-card'
  | 'create-cluster'
  | 'edit-card'
  | 'add-image'
  | 'edit-image'
  | null;

interface BoardEditingState {
  editingMode: BoardEditingMode;
  editingCardId: CardId | null;
  createCardTargetClusterId: CardId | null;
  createCardInitialText: string;
}

interface BoardEditingActions {
  startCreateCard: (initialText?: string, targetClusterId?: CardId | null) => void;
  startCreateCluster: () => void;
  startEditCard: (editingCardId: CardId) => void;
  startAddImage: () => void;
  startEditImage: (editingCardId: CardId) => void;
  stopEditing: () => void;
  resetBoardEditing: () => void;
}

export type BoardEditingStore = BoardEditingState & BoardEditingActions;

const initialState: BoardEditingState = {
  editingMode: null,
  editingCardId: null,
  createCardTargetClusterId: null,
  createCardInitialText: '',
};

export const useBoardEditingStore = create<BoardEditingStore>((set) => ({
  ...initialState,
  startCreateCard: (initialText = '', targetClusterId = null) =>
    set({
      createCardInitialText: initialText,
      createCardTargetClusterId: targetClusterId,
      editingMode: 'create-card',
      editingCardId: null,
    }),
  startCreateCluster: () =>
    set({
      createCardInitialText: '',
      createCardTargetClusterId: null,
      editingMode: 'create-cluster',
      editingCardId: null,
    }),
  startEditCard: (editingCardId) =>
    set({
      createCardInitialText: '',
      createCardTargetClusterId: null,
      editingMode: 'edit-card',
      editingCardId,
    }),
  startAddImage: () =>
    set({
      createCardInitialText: '',
      createCardTargetClusterId: null,
      editingMode: 'add-image',
      editingCardId: null,
    }),
  startEditImage: (editingCardId) =>
    set({
      createCardInitialText: '',
      createCardTargetClusterId: null,
      editingMode: 'edit-image',
      editingCardId,
    }),
  stopEditing: () => set(initialState),
  resetBoardEditing: () => set(initialState),
}));
